import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h2 futura bold color="#C60000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink
              href="https://www.instagram.com/ladysmithsushiwara/"
              target="_blank"
            >
              <CFImage
                w="50px"
                pr="10px"
                src={instagram}
                alt="Sushi Wara Instagram"
              />
            </CFLink>

            <CFLink
              href="https://www.facebook.com/SushiWaraLadysmith/"
              target="_blank"
            >
              <CFImage
                w="50px"
                pr="10px"
                src={facebook}
                alt="Sushi Wara facebook"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h2 futura bold color="#C60000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink
              href="https://www.instagram.com/ladysmithsushiwara/"
              target="_blank"
            >
              <CFImage
                w="50px"
                pr="10px"
                src={instagram}
                alt="Sushi Wara Instagram"
                hover
              />
            </CFLink>{' '}
            <CFLink
              href="https://www.facebook.com/SushiWaraLadysmith/"
              target="_blank"
            >
              <CFImage
                w="50px"
                pr="10px"
                src={facebook}
                alt="Sushi Wara Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
